import Header from 'components/header/Header';
import HeaderTitle from 'components/header/HeaderTitle/HeaderTitle';
import { KeyboardKeys, VerticalArrowKeys } from 'constants/';
import { useContainerFocus } from 'CustomHooks/useContainerFocus';
import { useEventListener } from 'CustomHooks/useEventListener';
import React, { memo, useRef } from 'react';
import { useTable } from 'react-table';

export const Table = ({
  columns,
  data,
  onRowClick,
  selectedRowIndex,
  bottomRef = null,
}) => {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({
    columns,
    data,
  });

  const tableContailerRef = useRef<HTMLDivElement>(null);
  const [isFocused] = useContainerFocus(tableContailerRef);

  useEventListener('keydown', (event: KeyboardEvent) => {
    if (!isFocused || !tableContailerRef.current) {
      return;
    }
    if (VerticalArrowKeys.includes(event.key as KeyboardKeys)) {
      const newIndex =
        event.key === KeyboardKeys.ArrowDown
          ? Math.min(selectedRowIndex + 1, data.length - 1)
          : Math.max(selectedRowIndex - 1, 0);
      onRowClick({ index: newIndex });
      const row = tableContailerRef.current.querySelector<HTMLTableRowElement>(
        `#scoreTable_1_${newIndex}`,
      );
      if (row) {
        row.scrollIntoView({
          block: 'center',
        });
      }
    }
  });

  return (
    <div id='scoretable-table-wrapper' ref={tableContailerRef} style={{ width: '100%' }}>
      <table id='scoretable-table-setup' className="setup-table" style={{ width: '100%' }} {...getTableProps()}>
        <thead id='scoretable-table-header' style={{ position: 'sticky', top: 0 }}>
          {headerGroups.map((headerGroup, i) => (
            <tr id={`scoresettings-table-headerGroup-${i}`} key={`headerGroup${i}`} {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <>
                  <div id={`scoresettings-table-header-separator`} className="th-sepration"></div>
                  <th
                    id={`scoresettings-table-header-${column.className}`}
                    style={column.style}
                    className={column.className}
                    {...column.getHeaderProps()}
                  >
                    {column.render('Header')}
                  </th>
                </>
              ))}
            </tr>
          ))}
        </thead>
        <tbody id={`scoresettings-table-body`} {...getTableBodyProps()}>
          {rows.map((row, i) => {
            prepareRow(row);
            const bgColor = +row.id === selectedRowIndex ? 'rgb(248, 151, 35)' : null;
            return (
              <tr
                id={`scoresettings-scoreTable-1-${i}`}
                key={`scoresettings-scoreTable-1-${i}`}
                {...row.getRowProps()}
                style={{ background: bgColor }}
                onClick={() => onRowClick(row)}
              >
                {row.cells.map((cell, index) => (
                  <td
                    id={`scoresettings-cell-${(cell.column as any).className || ['']}`}
                    key={`scoreTabler${index}`}
                    style={cell.style}
                    {...cell.getCellProps({
                      className: (cell.column as any).className || [''],
                    })}
                  >
                    {cell.render('Cell')}
                  </td>
                ))}
              </tr>
            );
          })}
          {bottomRef && <tr id='scoresettings-cell-bottom-invisible' className="invisible" ref={bottomRef}></tr>}
        </tbody>
      </table>
    </div>
  );
};
export default memo(Table);
